import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  detail: {},
  list: {
    items: [],
    page: 1,
    count: 0,
  },
};

export const counterSlice = createSlice({
  name: "stories",
  initialState,
  reducers: {
    setDetail: (state, action) => {
      state.detail = action.payload;
    },
    clearDetail: (state, action) => {
      state.detail = {};
    },
    setList: (state, action) => {
      state.list = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setDetail, setList, clearDetail } = counterSlice.actions;

export default counterSlice.reducer;
